import Cookies from "js-cookie"
import {makeStore, State} from "../ducks"
import {shufflePrimaryNav} from "../utils/personalisePrimaryNav"
import {MASID_COOKIE_NAME} from "../config/constants"

export const getStore = (_STATE_?: State) => {
    const state = _STATE_ || getState()
    const {
        settings: {personalisationEnabled},
    } = state
    const masIDCookie = personalisationEnabled ? Cookies.get(MASID_COOKIE_NAME) : "ID="
    const items = shufflePrimaryNav(state.primarynav.items, masIDCookie)
    // reproduce the store used to render the page on server
    const newState = {...state, primarynav: {...state.primarynav, items}}
    const store = makeStore(newState)
    return {store, newState}
}

export const getProps = () => {
    // Read the initial props as set by the server
    const {appProps} = (window as any).ssrClientSettings.header
    // delete the initial props from global window object
    return appProps
}

export const getState = () => {
    // Read the state sent with markup
    const {_STATE_} = (window as any).ssrClientSettings.header

    // delete the state from global window object
    return _STATE_
}
